module.exports = __webpack_public_path__ + "static/media/Tconcretesection.8a86ce13.svg";